import React from "react";
import { Row, Col, Container } from 'react-bootstrap';

import WyomingYogaWellness from '../../assets/2025/sponsors/wyOMingYoga&WellnessCowboy.webp';
import AtmanWellness from '../../assets/sponsors/2024/atmanWellness.webp';
import StandingMountain from '../../assets/2026/StandingMountain.webp';
import Lifetime from '../../assets/2026/lifetime.webp';
import InnerBlissYoga from '../../assets/2026/innerBlissYoga.webp';
import AcroYogaCasper from '../../assets/2025/sponsors/AcroYogaCasper.webp';

import "../../theme/index.css";

const sponsors = [
     { src: WyomingYogaWellness,    alt: "Wyoming Yoga & Wellness",         link: "https://wyomingyoga.com/" },
     { src: AtmanWellness,          alt: "Atman Wellness",                  link: "https://www.atmanwellnessllc.com/" },
     { src: StandingMountain,       alt: "Standing Mountain Counseling",    link: "https://mentalhealthhub307.com/standing-mountain" },
     { src: Lifetime,               alt: "Lifetime Health and Fitness",     link: "https://lifetime307.com/https://lifetime307.com/" },
     { src: InnerBlissYoga,         alt: "Inner Bliss Yoga",                link: "https://www.innerbliss-collective.com/" },
     { src: AcroYogaCasper,         alt: "Acro Yoga Casper",                link: "https://www.facebook.com/people/Acro-Yoga-Casper/61569482031027/" }   
];

export const SponsorList2026 = () => (
    <section className="px-0 mx-0 white-bkg-no-box">
        <Container>
            <Row className="pt-5 g-0">
                <Col className="text-center px-0">
                    <h2 className="bluegray-text">Thank you to our 2026 Sponsors!</h2>
                    <p>We are grateful to our generous sponsors whose support helps create a meaningful and memorable yoga festival experience for all attendees.</p>
                </Col>
            </Row>
            <Row className="justify-content-center align-items-center g-0 p-5">
                {sponsors.map((sponsor, idx) => (
                    <Col md={3} className="d-flex justify-content-center px-2 pt-2" key={idx}>
                        <a href={sponsor.link} rel="noreferrer" target="_blank">
                        <div className="logo-wrapper">
                            <img src={sponsor.src} alt={`${sponsor.alt} logo`} />
                        </div>
                        </a>
                    </Col>
                ))}
            </Row>
        </Container>
    </section>
);